
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class PacksDialog extends Serenity.EntityDialog<PacksRow, any> {
        protected getFormKey() { return PacksForm.formKey; }
        protected getIdProperty() { return PacksRow.idProperty; }
        protected getLocalTextPrefix() { return PacksRow.localTextPrefix; }
        protected getNameProperty() { return PacksRow.nameProperty; }
        protected getService() { return PacksService.baseUrl; }
        protected getDeletePermission() { return PacksRow.deletePermission; }
        protected getInsertPermission() { return PacksRow.insertPermission; }
        protected getUpdatePermission() { return PacksRow.updatePermission; }

        protected form = new PacksForm(this.idPrefix);

    }
}